import { render, staticRenderFns } from "./deviceClassification.vue?vue&type=template&id=c04d8f20&scoped=true"
import script from "./deviceClassification.vue?vue&type=script&lang=js"
export * from "./deviceClassification.vue?vue&type=script&lang=js"
import style0 from "./deviceClassification.vue?vue&type=style&index=0&id=c04d8f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04d8f20",
  null
  
)

export default component.exports